// 9fbef606107a605d69c0edbcd8029e5d
import { QMRECOMMENDATION_MODAL_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { getABtestFromState } from '../../../../../utils';

export const getQMRecommendationsModalState = (state) => {
  return state[QMRECOMMENDATION_MODAL_REDUCER_KEY];
};

export const getIsQMModalOpen = (state) => {
  const modalStatus = getQMRecommendationsModalState(state)?.get('modalStatus');
  return modalStatus && modalStatus.isModalOpen;
};

export const getIsShowQMModalGuest = (state) => {
  return getABtestFromState(state.AbTest).showQMModalGuest;
};

export const getIsShowQMModalLoggedIn = (state) => {
  return getABtestFromState(state.AbTest).showQMModalLoggedIn;
};

export const getRequestErrorCode = (state) => {
  const quntamMatrix = getQMRecommendationsModalState(state)?.get('QMRecommendationModal');
  return quntamMatrix && quntamMatrix.errorCode;
};
